import { ReactNode } from "react";
import { AuthProvider } from "./AuthContext";
import { LayoutProvider } from "./LayoutContent";
export const Contexts = ({ children }: { children: ReactNode }) => {
	return (
		<AuthProvider>
			<LayoutProvider>{children}</LayoutProvider>
		</AuthProvider>
	);
};
